import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ThermometerApiEnvelope,
  ThermometerCertificateRequest
} from 'src/app/Interface/DataEntity/DataEntityThermometerForm_Interface';
import { environment } from 'src/environments/environment';

export const DATA_ENTITY_THERMOMETER_FORM_ENDPOINT = 'api/Thermometer/ThermometerCertificate';

@Injectable({ providedIn: 'root' })
export class DataEntityThermometerFormService {
  constructor(private http: HttpClient) {}

  get(id: number): Observable<ThermometerApiEnvelope> {
    return this.http.get<ThermometerApiEnvelope>(
      `${environment.LabUrl}${DATA_ENTITY_THERMOMETER_FORM_ENDPOINT}?CalibrationDetailId=${id}`
    );
  }

  save(model: ThermometerCertificateRequest): Observable<ThermometerApiEnvelope> {
    return this.http.post<ThermometerApiEnvelope>(
      environment.LabUrl + DATA_ENTITY_THERMOMETER_FORM_ENDPOINT,
      model
    );
  }

  downloadFile(path: string): Observable<Blob> {
    const normalizedPath = path.trim().replace(/\\/g, '/');
    if (/^https?:\/\//i.test(normalizedPath)) {
      return this.http.get(normalizedPath, { responseType: 'blob' });
    }
    const wwwrootMarker = '/wwwroot/';
    const markerIndex = normalizedPath.toLowerCase().indexOf(wwwrootMarker);
    const publicPath = markerIndex >= 0
      ? normalizedPath.slice(markerIndex + wwwrootMarker.length)
      : normalizedPath;
    const relativePath = publicPath.indexOf('/') >= 0
      ? publicPath
      : `Certificates/thermometer/${publicPath}`;
    const url = `${environment.LabUrl.replace(/\/+$/, '')}/${relativePath.replace(/^\/+/, '')}`;
    return this.http.get(url, { responseType: 'blob' });
  }
}
